import { useTranslation } from "react-i18next";
import { useDispatch } from "src/store";
import { makeStyles } from "tss-react/mui";

import { showDetails } from "@dashboard/devices/store";
import { Box } from "@mui/material";
import { ActivityIcon } from "@shared/Loading";
import { getFormattedProgress } from "@shared/ProgressBar";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";
import { Tooltip } from "@shared/Tooltip";

import { Rollout } from "../../types";

const useStyles = makeStyles()((theme) => ({
    content: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    successIcon: {
        color: theme.palette.emteria.success,
    },
    errorIcon: {
        color: theme.palette.emteria.error,
    },
    mutedIcon: {
        color: theme.palette.emteria.indicator,
    },
}));

const StatusIcon = ({ rollout }: { rollout: Rollout }) => {
    const { t } = useTranslation(["pages"]);
    const { classes, cx } = useStyles();

    if (rollout.status === "active") {
        return <ActivityIcon tooltip={t("pages:rolloutsPage.table.progressStatus.active")} />;
    }

    if (rollout.status === "cancelled") {
        return (
            <Tooltip title={t("pages:rolloutsPage.table.progressStatus.cancelled")}>
                <i className={cx("fa-solid fa-fw fa-ban", classes.mutedIcon)} />
            </Tooltip>
        );
    }

    if (rollout.progress >= 100) {
        return (
            <Tooltip title={t("pages:rolloutsPage.table.progressStatus.complete")}>
                <i className={cx("fa-regular fa-fw fa-circle-check", classes.successIcon)} />
            </Tooltip>
        );
    }

    return (
        <Tooltip title={t("pages:rolloutsPage.table.progressStatus.incomplete")}>
            <i className={cx("fa-regular fa-fw fa-circle-xmark", classes.errorIcon)} />
        </Tooltip>
    );
};

export const RolloutProgressCell = ({ rollout }: { rollout: Rollout }) => {
    const dispatch = useDispatch();
    const { classes } = useStyles();

    return (
        <MinimalTableCell onClick={() => dispatch(showDetails({ type: "rollout", selectedId: rollout.id }))}>
            <Box className={classes.content}>
                <StatusIcon rollout={rollout} />
                {getFormattedProgress(rollout.progress)}
            </Box>
        </MinimalTableCell>
    );
};
